import { isJSONString } from "./isJSONString";

export const getItem = (TOKEN_KEY: string): string | null => {
  const value = localStorage.getItem(TOKEN_KEY);

  if (value && isJSONString(value)) {
    return JSON.parse(value);
  }

  return value;
};

export const removeItem = (TOKEN_KEY: string): void => {
  localStorage.removeItem(TOKEN_KEY);
};

export const setItem = (TOKEN_KEY: string, newValue: string): void => {
  localStorage.setItem(TOKEN_KEY, newValue);
};

export const clearLocalStorage = (): void => localStorage.clear();
